export default __webpack_public_path__ + "static/media/writer.281b9a13.webp";